<div class="row">
    <div class="col-12 col-md-3">
        <div class="card rounded-0" >
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Integration</h3>
                    <div class="mb-3">
                        <label for="provider" class="form-label">Provider <em>*</em></label>
                        <select class="form-control" name="provider" #provider="ngModel" [(ngModel)]="data.provider" required>
                            <option [value]="'etg'">ETG</option>
                            <option [value]="'ct88'">CT88</option>
                        </select>
                    </div>
                    <ng-container *ngIf="data.provider == 'etg'">
                        <div class="mb-3">
                            <label for="op_code" class="form-label">Operator Code <em>*</em></label>
                            <input type="text" class="form-control" id="op_code" name="op_code" #op_code="ngModel" [(ngModel)]="data.op_code" maxlength="4" required>
                            <div *ngIf="f.submitted && op_code.invalid" class="invalid-feedback">
                                <div *ngIf="op_code.errors.required">Operation code is required</div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="secret" class="form-label">Secret <em>*</em></label>
                            <input type="password" class="form-control" id="secret" name="secret" #secret="ngModel" [(ngModel)]="data.secret" required>
                            <div *ngIf="f.submitted && secret.invalid" class="invalid-feedback">
                                <div *ngIf="secret.errors.required">Secret is required</div>
                            </div>
                        </div>
                        <div>
                            <label for="secret" class="form-label">Available Games for Integration<em>*</em></label>
                            <ul>
                                <li>Pussy</li>
                                <li>LPE</li>
                                <li>Newtown</li>
                                <li>Joker</li>
                                <li>Suncity</li>
                                <li>Playboy</li>
                                <li>ACE333</li>
                                <li>Live 22</li>
                                <li>Rolex</li>
                                <li>918Kaya</li>
                                <li>King855</li>
                                <li>SKY777</li>
                            </ul>
                        </div>
                    </ng-container>

                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                            <option [value]="1">Active</option>
                            <option [value]="0">Disabled</option>
                        </select>
                        <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                            <div *ngIf="status.errors.required">Status is required</div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary">Add Integration</button>
                </form>
            </div>
        </div>
    </div>
</div>